<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain class="pb-0 pb-md-12" maxwidth-container="700px">
      <ContasStepper />
    </InternaMain>
  </Wrapper>
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import ContasStepper from '@/components/MeuPerfil/ContasBancarias/ContasStepper.vue';

export default {
  name: 'ContasBancariasCadastrar',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    ContasStepper,
  },
};
</script>
